import React from 'react'
import moment from 'moment'
import { Row, Col, Typography, Descriptions, Divider } from 'antd'

const { Text } = Typography

export default function WorkExperience(props) {
  const { data } = props
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Descriptions title="Work Experiences" />
        {
          data.listWorkExperience.length > 0 ?
            <React.Fragment>
              {
                data.listWorkExperience.map((item, i) => (
                  <React.Fragment key={i}>
                    <div style={{ marginBottom: 11 }}>
                      <Text style={{ color: '#32ab6d', fontSize: 14 }}>
                        {moment(item.startDate, 'YYYY-MM').format('MMMM YYYY')} - {item.endDate ? moment(item.endDate, 'YYYY-MM').format('MMMM YYYY') : 'Present'}
                      </Text>
                    </div>
                    <Descriptions layout="vertical" size="small" column={3}>
                      <Descriptions.Item label="Title">
                        {item.title}
                      </Descriptions.Item>
                      <Descriptions.Item label="Employment Type">
                        {
                          item.employmentType ?
                          <Text>
                            {item.employmentType === "FULL_TIME" && 'Full Time'}
                            {item.employmentType === "PART_TIME" && 'Part Time'}
                            {item.employmentType === "FREELANCE" && 'Freelance'}
                            {item.employmentType === "INTERNSHIP" && 'Internship'}
                          </Text>
                          :
                          'N/A'
                        }
                      </Descriptions.Item>
                      <Descriptions.Item label="Company">
                        {item.company ? item.company : 'N/A'}
                      </Descriptions.Item>
                    </Descriptions>
                    <Descriptions layout="vertical" size="small" column={3}>
                      <Descriptions.Item label="Location">
                        {item.provinceName ? item.provinceName : 'N/A'}
                      </Descriptions.Item>
                      <Descriptions.Item label="Job Description">
                        {item.jobDescription ? item.jobDescription : 'N/A'}
                      </Descriptions.Item>
                    </Descriptions>
                    <Divider />
                  </React.Fragment>
                ))
              }
            </React.Fragment>
          :
            <React.Fragment>
              <Text>N/A</Text>
              <Divider />
            </React.Fragment>
        }
      </Col>
    </Row>
  )
}
